import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { Row, Col, Image, Card, ListGroup, Button, Container } from 'react-bootstrap';
import { ArrowLeft } from 'lucide-react';
import { teamData } from '../data/team';
import Footer from '../components/Footer';

const TeamMemberDetail = () => {
    const { slug } = useParams();
    const member = teamData[slug];

    if (!member) {
        return (
            <div className="text-center">
                <h2>Team Member Not Found</h2>
                <Link to="/">
                    <Button variant="primary">Back to Team List</Button>
                </Link>
            </div>
        );
    }

    return (
        <>
            <div className="hero-section text-center text-white" style={{
                backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('/static/OT-Surgery-3-scaled.webp')`, // Replace with your hero image
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                padding: '100px 0',
                minHeight: '40vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }}>
            </div>

            <Container className='my-5'>
                <Row className='mb-5'>
                    <Col md={6} className="text-center">
                        <Image src={member.imageUrl} alt={member.name} fluid style={{ border: '5px solid #f0f0f0' }} />
                    </Col>
                    <Col md={6}>

                        <p className="lead text-muted">{member.designation}</p>
                        <p>{member.intro}</p>
                        {/* <div className="mt-4">
                            {Object.entries(member.profile).map(([title, items]) => (
                                <Card key={title} className="mb-4 border-0 shadow-sm">
                                    <Card.Header as="h5" className="fw-bold bg-light">{title}</Card.Header>
                                    <ListGroup variant="flush">
                                        {items.map((item, index) => (
                                            <ListGroup.Item key={index} className="border-0">{item}</ListGroup.Item>
                                        ))}
                                    </ListGroup>
                                </Card>
                            ))}
                        </div> */}
                    </Col>
                </Row>
                <Container className='mt-5 p-5' style={{ backgroundColor: '#edfafa' }}>
                    <h1 className="fw-bold">{member.name}</h1>
                    <p style={{ color: "#4aa15e" }} >{member.highlight}</p>
                    <div className='mt-5'>
                        {member.details.map((detail, index) => {
                            return (
                                <div key={index} md={12} className="mb-4">
                                    <p className="fw-bold">{detail.title}</p>
                                    <p>{detail.description}</p>
                                </div>
                            );
                        })}
                    </div>
                </Container>


            </Container>

            <Footer />
        </>
    );
};

export default TeamMemberDetail;